import {Col, Row} from "react-bootstrap";
import Skeleton from "react-loading-skeleton/lib";
import React from "react";
import {connect} from "react-redux";
import {formatTime} from "../actions/actionCreators";
import i18n from "../i18nextInitiator";

/**
 * This is the funciton to access translations.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');

const mapStateToProps = state => ({...state});

const InvoiceDetails = (props) => {
    const {
        invoice: {
            bill = {}
        }
    } = props;
    return (
        <>
            <Row>
                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("invoice.id")}</div>
                        <div className='sub-label'> {bill.id || <Skeleton/>}
                        </div>
                    </div>
                </Col>

                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("invoice.receiver-name")}</div>
                        <div className='sub-label'> {bill.receiver_name || <Skeleton/>}
                        </div>
                    </div>
                </Col>

                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("invoice.receiver-phone")}</div>
                        <div className='sub-label'> {bill.phone || <Skeleton/>}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("location.origin")}</div>
                        <div className='sub-label'>
                            {bill.origin_address || <Skeleton height={25} count={3}/>}
                        </div>
                    </div>
                </Col>
                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("location.destination")}</div>
                        <div className='sub-label'>
                            {bill.destination_address || <Skeleton height={25} count={3}/>}
                        </div>
                    </div>
                </Col>
                <Col md={4} xs={6}>
                    <div className='invoice-group'>
                        <div className='label'>{t("time.time")}</div>
                        <div className='sub-label'>
                            {bill.time ? formatTime(bill.time) : <Skeleton height={25}/>}
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className='invoice-group'>
                        <div className='label'>{t("invoice.driver-name")}</div>
                        <div className='sub-label'>
                            {bill.driver ? bill.driver.name : ""}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default connect(mapStateToProps)(InvoiceDetails);
